// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Me42","row":"ProcedureTreatmentSummary_row__3wrbs"};